import { computed, onMounted, onUnmounted, ref } from 'vue'
import axios from 'axios'
import { extractData } from '../utils/api.js'
import { getDismissedAnnouncementIds, dismissAnnouncementId } from '../utils/announcements.js'

const allItems = ref([])
const dismissedIds = ref(getDismissedAnnouncementIds())
const sessionDismissedModalIds = ref(new Set())
let pollTimer = null
let initCount = 0

async function fetchAnnouncements() {
  try {
    const res = await axios.get('/api/announcements/active')
    const data = extractData(res)
    allItems.value = Array.isArray(data?.items) ? data.items : []
  } catch {
    /* 静默失败，不影响主功能 */
  }
}

/** @returns {{ visibleMarqueeItems: import('vue').ComputedRef<any[]>, visibleModalItems: import('vue').ComputedRef<any[]>, dismiss: (id: number, opts?: { persist?: boolean }) => void, refresh: () => Promise<void> }} */
export function useActiveAnnouncements() {
  onMounted(() => {
    initCount += 1
    if (initCount === 1) {
      fetchAnnouncements()
      pollTimer = setInterval(fetchAnnouncements, 5 * 60 * 1000)
    }
  })

  onUnmounted(() => {
    initCount -= 1
    if (initCount <= 0) {
      initCount = 0
      if (pollTimer) {
        clearInterval(pollTimer)
        pollTimer = null
      }
    }
  })

  const visibleMarqueeItems = computed(() =>
    allItems.value.filter(
      (item) => item.display_type === 'marquee' && !dismissedIds.value.has(Number(item.id))
    )
  )

  const visibleModalItems = computed(() =>
    allItems.value.filter(
      (item) =>
        item.display_type === 'modal' &&
        !dismissedIds.value.has(Number(item.id)) &&
        !sessionDismissedModalIds.value.has(Number(item.id))
    )
  )

  function dismiss(id, { persist = true } = {}) {
    const numId = Number(id)
    if (!numId) return
    if (persist) {
      dismissAnnouncementId(numId)
      dismissedIds.value = getDismissedAnnouncementIds()
      return
    }
    sessionDismissedModalIds.value = new Set([...sessionDismissedModalIds.value, numId])
  }

  return {
    visibleMarqueeItems,
    visibleModalItems,
    dismiss,
    refresh: fetchAnnouncements,
  }
}
